import React, {FC, ReactNode} from 'react';

import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';

import useWindowSize from '@/hooks/WindowSize/WindowSize';

import './styles';

interface CustomDialogProps {
  open: boolean;
  header?: string | false;
  closeWhenClickOutside?: boolean;
  closable?: boolean;
  children?: ReactNode;
  footer?: ReactNode;
  isBottomSheet?: boolean;
  paperStyle?: React.CSSProperties;
  onClose: () => void;
}

const CustomDialog: FC<CustomDialogProps> = ({
  open,
  header = '',
  closeWhenClickOutside = true,
  closable = true,
  children,
  footer,
  isBottomSheet,
  paperStyle,
  onClose,
}) => {
  const {isMobile} = useWindowSize();
  return (
    <Dialog
      open={open}
      onClose={closeWhenClickOutside ? onClose : undefined}
      className="dialog"
      PaperProps={{
        style: isMobile
          ? {
              width: isBottomSheet ? '100%' : '90%',
              margin: 0,
              bottom: isBottomSheet ? 0 : 'auto',
              position: isBottomSheet ? 'fixed' : 'absolute',
              backgroundColor: 'white',
              ...(paperStyle ? paperStyle : {}),
            }
          : {
              backgroundColor: 'white',
              ...(paperStyle ? paperStyle : {}),
            },
      }}
      disableEscapeKeyDown={!closable}>
      {header !== 'false' && (
        <DialogTitle
          className="dialog-header"
          sx={{background: 'white'}}>
          <span className="dialog-title">{header}</span>
          {closable && (
            <IconButton
              aria-label="close"
              onClick={onClose}
              className="dialog-header-icons">
              <CloseIcon className="dialog-header-icon" />
            </IconButton>
          )}
        </DialogTitle>
      )}

      <DialogContent
        sx={{
          paddingBottom: 5,
          maxHeight: isBottomSheet ? 'auto' : 450,
          maxWidth: isMobile && isBottomSheet ? '100%' : 456,
          margin: 0,
          background: 'white',
        }}>
        {children}
      </DialogContent>

      <DialogActions
        sx={{
          background: 'white',
          marginBottom: isMobile && isBottomSheet ? 2 : 0,
          paddingInline: 2,
        }}>
        {footer && (
          <Box
            width={'100%'}
            component="div">
            {footer}
          </Box>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default CustomDialog;
